import { render, staticRenderFns } from "./CompanyRequestDetails.vue?vue&type=template&id=5ba11a8c"
import script from "./CompanyRequestDetails.vue?vue&type=script&lang=js"
export * from "./CompanyRequestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports